import { Box, Flex, DeprecatedIcon, Typography } from '@fullstory/components';
import { useHover } from '@fullstory/react-hooks';
import React, { FC, useState } from 'react';
import { ServerEventButton } from '../ServerEventButton';
import { SERVER } from '../UserOverlay/utils';
import { UserOverlayExpandableListItem } from '../UserOverlayExpandableListItem';

interface ServerEventClipListItemProps {
  serverEventVars?: string;
  serverEventName?: string;
  serverIntegrationName?: string;
  title: string;
}

export const ServerEventClipListItem: FC<ServerEventClipListItemProps> = ({
  serverEventName,
  serverEventVars,
  serverIntegrationName,
  title,
}) => {
  const { hovered: isHovered, hoverProps } = useHover();
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  return (
    <UserOverlayExpandableListItem
      data-component="ServerEventClipListItem"
      isExpanded={isExpanded}
      serverEventVars={serverEventVars}
    >
      <Flex justifyContent="space-between">
        <Flex alignItems="center" style={{ gap: 5 }}>
          <Box paddingRight={8}>
            <ServerEventButton
              isHovered={isHovered}
              isExpanded={isExpanded}
              onClick={() => setIsExpanded(isExpaned => !isExpaned)}
              {...hoverProps}
            />
          </Box>
          <Flex alignItems="flex-start" style={{ flexDirection: 'column' }}>
            <Typography ellipsize variant="body3">
              {title}
            </Typography>
            <Typography color="neutrals-n7" variant="body3" ellipsize>
              {serverEventName}
            </Typography>
          </Flex>
        </Flex>
        <Flex alignItems="flex-end">
          <Typography color="neutrals-n7" variant="body3" ellipsize>
            {serverIntegrationName}
          </Typography>
          <Flex alignItems="flex-end" style={{ flexDirection: 'column' }}>
            <Typography ellipsize variant="body3">
              {SERVER}
            </Typography>
            <Box>
              <DeprecatedIcon name="device-server" color="neutrals-n6" size={20} />
            </Box>
          </Flex>
        </Flex>
      </Flex>
    </UserOverlayExpandableListItem>
  );
};
